import React from "react";
import PropTypes from "prop-types";
import { withUser } from "@unifiedpatents/sso";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const ZendeskNewRequestLink = props => {
  const { user, text, subjectPrefix, style, className } = props;
  const reportedUrl = window.location.href;
  let zendeskLink = `https://support.unifiedpatents.com/hc/en-us/requests/new?subject=${encodeURIComponent(subjectPrefix)}+${encodeURIComponent(reportedUrl)}`;
  if (user && user.profile && user.profile.email) {
    zendeskLink += `&email=${user.profile.email}`;
  }
  return (
    <a target="_new" href={zendeskLink} style={style} className={className}>
      <ExclamationCircleOutlined style={{ marginRight: 4 }} />
      {text}
    </a>
  );
};

ZendeskNewRequestLink.propTypes = {
  text: PropTypes.node,
  subjectPrefix: PropTypes.string
};

export default withUser(ZendeskNewRequestLink);
